import { render, staticRenderFns } from "./stockUp.vue?vue&type=template&id=5cc74d58&scoped=true&"
import script from "./stockUp.vue?vue&type=script&lang=js&"
export * from "./stockUp.vue?vue&type=script&lang=js&"
import style0 from "./stockUp.vue?vue&type=style&index=0&id=5cc74d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc74d58",
  null
  
)

export default component.exports